import React, { FC } from 'react';
import Form from 'components/Form';

import { StrepsilsPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Strepsils: FC<StrepsilsPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Strepsils;
